var _circle, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDivicesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 67,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 59,
    r: 59,
    fill: "#00CA7D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_610_217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6663 40.6667H23.333C20.5663 40.6667 18.333 42.9001 18.333 45.6667V72.3334C18.333 75.1001 20.5663 77.3334 23.333 77.3334H36.6663C39.433 77.3334 41.6663 75.1001 41.6663 72.3334V45.6667C41.6663 42.9001 39.433 40.6667 36.6663 40.6667ZM33.333 74.0001H26.6663V72.3334H33.333V74.0001ZM38.7497 69.0001H21.2497V45.6667H38.7497V69.0001Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_610_217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.3333 70.5001C94.4417 70.5001 96.1475 68.7751 96.1475 66.6667L96.1667 47.5001C96.1667 45.3917 94.4417 43.6667 92.3333 43.6667H61.6667C59.5583 43.6667 57.8333 45.3917 57.8333 47.5001V66.6667C57.8333 68.7751 59.5583 70.5001 61.6667 70.5001H54V74.3334H100V70.5001H92.3333ZM61.6667 47.5001H92.3333V66.6667H61.6667V47.5001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_610_217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(10 39)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_610_217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white",
    transform: "translate(54 36)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivicesActive);
export default __webpack_public_path__ + "static/media/divicesActive.2484f70be76f4c08599cb849edf976ee.svg";
export { ForwardRef as ReactComponent };